import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { msalInstance } from 'auth/msalInstance';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const NODE_ENV = process.env.NODE_ENV;
console.log('Application mode:' + NODE_ENV + ' mode');

msalInstance.initialize()
  .then(() => msalInstance.handleRedirectPromise())
  .then(() => {
    if (NODE_ENV === 'development') {
      root.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>
      );
    } else {
      root.render(<App />);
    }
  })
  .catch(console.error);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
